import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountDetailsComponent } from './components/account-details/account-details.component';
import { AuthCallbackComponent } from './components/auth/auth-callback/auth-callback.component';
import { CardListItemComponent } from './components/cards/card-list-item/card-list-item.component';
import { MemberCardComponent } from './components/member-card/member-card.component';
import { SingleSignOnComponent } from './components/single-sign-on/single-sign-on.component';
import { UserLoginComponent } from './components/user-login/user-login.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { BarcodeComponent } from './components/barcode/barcode.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { QRCodeModule } from 'angularx-qrcode';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PointsSummaryComponent } from './components/points-summary/points-summary.component';
import { EcashBalanceComponent } from './components/ecash-balance/ecash-balance.component';
import { RouterModule } from '@angular/router';
import { PointsSummaryBarComponent } from './components/points-summary-bar/points-summary-bar.component';
import { MlbamUserLoginComponent } from './components/mlbam-user-login/mlbam-user-login.component';
import { MlbamAccountSelectionComponent } from './components/mlbam-account-selection/mlbam-account-selection.component';
import { TransactionListComponent } from './components/transaction-list/transaction-list.component';
import { TransactionHistoryComponent } from './components/transaction-history/transaction-history.component';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { CardListComponent } from './components/cards/card-list/card-list.component';
import { CardSelectComponent } from './components/cards/card-select/card-select.component';
import { AddressSelectorComponent } from './components/address-selector/address-selector.component';
import { PointsManagementPlaceholderComponent } from './components/points-management-placeholder/points-management-placeholder.component';
import { PointsTransferComponent } from './components/points-transfer/points-transfer.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { PartnerListComponent } from './components/partner-list/partner-list.component';
import { PartnerPendingListComponent } from './components/partner-pending-list/partner-pending-list.component';
import { PartnerAddFormComponent } from './components/partner-add-form/partner-add-form.component';
import { PartnerAcceptFormComponent } from './components/partner-accept-form/partner-accept-form.component';
import { AveragePointsComponent } from './components/average-points/average-points.component';
import { TmUserLoginComponent } from './components/tm-user-login/tm-user-login.component';
import { EditAccountDetailsComponent } from './components/edit-account-details/edit-account-details.component';
import { AlertPreferencesComponent } from './components/alert-preferences/alert-preferences.component';
import { V1SingleSignOnComponent } from './components/v1-single-sign-on/v1-single-sign-on.component';
import { SportsAllianceUserLoginComponent } from './components/sports-alliance-user-login/sports-alliance-user-login.component';
import { GbgIdentityStatusComponent } from './components/gbg-identity-status/gbg-identity-status.component';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { ErrorsModule } from '@fgb/portal-component-library/src/lib/shared/errors';
import { DateRangePickerModule } from '@fgb/portal-component-library/src/lib/shared/date-range-picker';
import { CashBackToggleModule } from '@fgb/portal-component-library/src/lib/ecash/cash-back-toggle';
import { LoadingModule } from '@fgb/portal-component-library/src/lib/shared/loading';
import { KeyCloakUserLoginComponent } from './components/key-cloak-user-login/key-cloak-user-login.component';
import { SeatGeekUserLoginComponent } from './components/seatgeek-user-login/seatgeek-user-login.component';
import { MobilePassModule } from '@fgb/portal-component-library/src/lib/passes/mobile-pass';
import { SplitTransactionModule } from './components/split-transaction/split-transaction.module';
import { UserResetPasswordComponent } from './components/user-reset-password/user-reset-password.component';
import { UserChangePasswordComponent } from './components/user-change-password/user-change-password.component';
import { InvalidTokenModalComponent } from './components/invalid-token-modal/invalid-token-modal.component';
import { PopupAddToHomeScreenComponent } from './components/popup-add-to-home-screen/popup-add-to-home-screen.component';
import { EnduranceZoneUserLoginComponent } from './components/endurance-zone-user-login/endurance-zone-user-login.component';
import { LanguageSelectorModule } from '@fgb/portal-component-library/src/lib/shared/language-selector/language-selector.module';
import { RepresentativeComponent } from './components/representative/representative.component';
import { FacialRecognitionEntryComponent } from './components/facial-recognition/facial-recognition-entry/facial-recognition-entry.component';
import { ReferAFriendComponent } from './components/refer-a-friend/refer-a-friend.component';
import { FacialRecognitionImageUploaderComponent } from './components/facial-recognition/facial-recognition-image-uploader/facial-recognition-image-uploader.component';
import { FacialRecognitionUploaderHeaderComponent } from './components/facial-recognition/facial-recognition-uploader-header/facial-recognition-uploader-header.component';
import { FacialRecognitionUploaderButtonComponent } from './components/facial-recognition/facial-recognition-uploader-button/facial-recognition-uploader-button.component';
import { FacialRecognitionUploaderInfoComponent } from './components/facial-recognition/facial-recognition-uploader-info/facial-recognition-uploader-info.component';
import { FacialRecognitionTakePhotoComponent } from './components/facial-recognition/facial-recognition-take-photo/facial-recognition-take-photo.component';
import { FacialRecognitionReviewPhotoComponent } from './components/facial-recognition/facial-recognition-review-photo/facial-recognition-review-photo.component';
import { FacialRecognitionValidatingPhotoComponent } from './components/facial-recognition/facial-recognition-validating-photo/facial-recognition-validating-photo.component';
import { FacialRecognitionReviewPhotoFailedComponent } from './components/facial-recognition/facial-recognition-review-photo-failed/facial-recognition-review-photo-failed.component';
import { FacialRecognitionPhotoSuccessComponent } from './components/facial-recognition/facial-recognition-photo-success/facial-recognition-photo-success.component';
import { FacialRecognitionStepperComponent } from './components/facial-recognition/facial-recognition-stepper/facial-recognition-stepper.component';
import { FacialRecognitionStepComponent } from './components/facial-recognition/facial-recognition-step/facial-recognition-step.component';
import { EcashButtonComponent } from './components/ecash-button/ecash-button.component';
import { WebcamModule } from 'ngx-webcam';
import { FacialRecognitionModalComponent } from './components/facial-recognition/facial-recognition-modal/facial-recognition-modal.component';
import { SalesForceUserLoginComponent } from './components/sales-force-user-login/sales-force-user-login.component';
import { FitnessTrackerCardComponent } from './components/fitness-tracker-card/fitness-tracker-card.component';
import { MobilePageHeaderComponent } from './components/mobile-page-header/mobile-page-header.component';
import { AccountNavComponent } from './components/account-nav/account-nav.component';
import { AccountPanelComponent } from './components/account-panel/account-panel.component';
import { AccountIdentityHeaderComponent } from './components/account-identity-header/account-identity-header.component';
import { AccountLayoutComponent } from './components/account-layout/account-layout.component';
import { MobileHeaderComponent } from './components/mobile-header/mobile-header.component';
import { MembershipProgressComponent } from './components/membership-progress/membership-progress.component';

@NgModule({
  declarations: [
    AccountDetailsComponent,
    AuthCallbackComponent,
    CardListItemComponent,
    MemberCardComponent,
    SingleSignOnComponent,
    UserLoginComponent,
    BarcodeComponent,
    EcashBalanceComponent,
    PointsSummaryComponent,
    ReferAFriendComponent,
    PointsSummaryBarComponent,
    MlbamUserLoginComponent,
    MlbamAccountSelectionComponent,
    TransactionListComponent,
    TransactionHistoryComponent,
    CardListComponent,
    CardSelectComponent,
    AddressSelectorComponent,
    PointsManagementPlaceholderComponent,
    PointsTransferComponent,
    PartnerListComponent,
    PartnerPendingListComponent,
    PartnerAddFormComponent,
    PartnerAcceptFormComponent,
    AveragePointsComponent,
    TmUserLoginComponent,
    EditAccountDetailsComponent,
    AlertPreferencesComponent,
    V1SingleSignOnComponent,
    SportsAllianceUserLoginComponent,
    KeyCloakUserLoginComponent,
    GbgIdentityStatusComponent,
    SeatGeekUserLoginComponent,
    UserResetPasswordComponent,
    UserChangePasswordComponent,
    InvalidTokenModalComponent,
    PopupAddToHomeScreenComponent,
    EnduranceZoneUserLoginComponent,
    RepresentativeComponent,
    FacialRecognitionEntryComponent,
    FacialRecognitionImageUploaderComponent,
    FacialRecognitionUploaderHeaderComponent,
    FacialRecognitionUploaderButtonComponent,
    FacialRecognitionUploaderInfoComponent,
    FacialRecognitionTakePhotoComponent,
    FacialRecognitionReviewPhotoComponent,
    FacialRecognitionValidatingPhotoComponent,
    FacialRecognitionReviewPhotoFailedComponent,
    FacialRecognitionPhotoSuccessComponent,
    FacialRecognitionStepperComponent,
    FacialRecognitionStepComponent,
    EcashButtonComponent,
    FacialRecognitionModalComponent,
    SalesForceUserLoginComponent,
    FitnessTrackerCardComponent,
    MobilePageHeaderComponent,
    AccountNavComponent,
    AccountPanelComponent,
    AccountIdentityHeaderComponent,
    AccountLayoutComponent,
    MobileHeaderComponent,
    MembershipProgressComponent,
  ],
  exports: [
    AccountDetailsComponent,
    AuthCallbackComponent,
    CardListItemComponent,
    MemberCardComponent,
    SingleSignOnComponent,
    UserLoginComponent,
    BarcodeComponent,
    EcashBalanceComponent,
    PointsSummaryComponent,
    ReferAFriendComponent,
    PointsSummaryBarComponent,
    MlbamUserLoginComponent,
    MlbamAccountSelectionComponent,
    TransactionHistoryComponent,
    CardListComponent,
    CardSelectComponent,
    AddressSelectorComponent,
    PointsManagementPlaceholderComponent,
    PointsTransferComponent,
    PartnerListComponent,
    PartnerPendingListComponent,
    PartnerAddFormComponent,
    PartnerAcceptFormComponent,
    AveragePointsComponent,
    TmUserLoginComponent,
    EditAccountDetailsComponent,
    AlertPreferencesComponent,
    V1SingleSignOnComponent,
    SportsAllianceUserLoginComponent,
    KeyCloakUserLoginComponent,
    GbgIdentityStatusComponent,
    SeatGeekUserLoginComponent,
    SplitTransactionModule,
    PopupAddToHomeScreenComponent,
    EnduranceZoneUserLoginComponent,
    RepresentativeComponent,
    FacialRecognitionEntryComponent,
    FacialRecognitionImageUploaderComponent,
    EcashButtonComponent,
    SalesForceUserLoginComponent,
    FitnessTrackerCardComponent,
    MobilePageHeaderComponent,
    AccountNavComponent,
    AccountPanelComponent,
    AccountIdentityHeaderComponent,
    AccountLayoutComponent,
    MobileHeaderComponent,
    MembershipProgressComponent,
  ],
  imports: [
    NgbModule,
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    QRCodeModule,
    RouterModule,
    InlineSVGModule,
    CarouselModule,
    DateRangePickerModule,
    ErrorsModule,
    CashBackToggleModule,
    LoadingModule,
    FGBSharedModule,
    MobilePassModule,
    SplitTransactionModule,
    LanguageSelectorModule,
    WebcamModule,
  ],
})
export class UserModule {}
